import type {ValidationMessageTemplate} from "@vee-validate/i18n"

export default {
    messages: {
        "verify_password": "Das Passwort ist zu schwach. Bitte wähle ein stärkeres Passwort",
        "confirm_password": "Das Passwort stimmt nicht überein",
        "verify_url": "URL ist ungültig",
        "validation_pending": "Wird geprüft...",
        "editor_content_required": "{field} ist ein Pflichtfeld",
        "puzzle_unsolved": "Du hast dieses Rätsel noch nicht gelöst..."
    }
} as {
    messages: Record<string, ValidationMessageTemplate>
}
